/**
 * @author Pascal Lehnert (Ideenmühle) <pascal.lehnert@ideenmuehle.com>
 */
import {ProspectForm} from "@app/components/ProspectForm";
// const jQuery = window.jQuery;

class RiedlProspectGenerator {
    constructor() {
        new ProspectForm();

        this.customTooltip({})

        // $(document).on('resize', () => {
        //
        //     const tooltips = $('figure.image-tooltip .collection-grid__image-overlay')
        //
        //     $(window).on('resize', () => {
        //         tooltips.each((index, tt) => {
        //             $(tt).off('hover mousemove')
        //                 .unbind('hover mousemove')
        //         })
        //
        //         this.customTooltip({})
        //     })
        // })
    }

    setToolTipPosition($tooltip, options, element) {
        const tooltipHeight = $tooltip.height() ?? 0;
        const popupScollTop = $(element.delegateTarget).closest('.popup').scrollTop() ?? 0

        options.yOffset = tooltipHeight / 2
        let yPosition = element.clientY - options.yOffset + popupScollTop

        $tooltip.css({
            top: yPosition + "px",
            left: element.clientX + options.xOffset + "px"
        }).fadeIn(300)

        const tooltipTop = $tooltip.offset()?.top ?? 0;
        const viewportTop = $(window).scrollTop() ?? 0;
        const viewportBottom = viewportTop + ($(window).height() ?? 0);

        // console.log('Tooltip Position', {
        //     // 'is greater vw bottom': tooltipTop + tooltipHeight > viewportBottom,
        //     'tooltiptop': tooltipTop,
        //     'height': tooltipHeight,
        //     'tt top + height': tooltipTop + tooltipHeight,
        //     'vw bottom': viewportBottom,
        //     'popup Scroll top': popupScollTop
        // })

        if (tooltipTop < viewportTop) {
            // console.warn('tooltipTop < viewportTop', tooltipTop < viewportTop)

            $tooltip.css({
                top: viewportTop + (tooltipHeight / 1.8) + (popupScollTop - (tooltipHeight/2)) + "px",
            })
        } else if (tooltipTop + tooltipHeight > viewportBottom) {
            // console.warn('tooltipTop + tooltipHeight > viewportBottom')

            $tooltip.css({
                top: viewportBottom - tooltipHeight + popupScollTop - 20 + "px",
            })
        }
    }

    customTooltip(customOptions = {}) {
        const self = this

        if (window.innerWidth < 1200) {
            return
        }

        const options = $.extend({
            xOffset: 30,
            yOffset: 30
        }, customOptions);

        const tooltips = $('figure.image-tooltip .collection-grid__image-overlay')

        tooltips.each(function (index, item) {
            var $tooltipItem = $(item);

            $tooltipItem.hover(function (element) {

                // console.log('Tooltip', {
                //     screenY: element.screenY,
                //     pageY: element.pageY,
                //     offsetY: element.offsetY,
                //     clientY: element.clientY
                // })

                const imageUrl = $(element.delegateTarget).find('img').attr('src');

                $("#prospect-pages").append("<p id='image-tooltip'><img src='" + imageUrl + "' alt='Image preview' /></p>")

                const $tooltip = $('#image-tooltip')
                self.setToolTipPosition($tooltip, options, element)

            }, function () {
                $("#image-tooltip").remove()
            })

            $tooltipItem.mousemove(function (element) {

                const $tooltip = $('#image-tooltip')
                self.setToolTipPosition($tooltip, options, element)
            })
        })
    }
}

;(function ($) {
    new RiedlProspectGenerator()
})(jQuery)
